import { Injectable } from '@angular/core';

import { map, take, Observable } from 'rxjs';

import { FrontendModalService, FrontendModalSize } from '@tablesready/frontend-modal';
import {
  ConfirmationCheckboxModalComponent,
  ConfirmationCheckboxModalResult
} from './confirmation-checkbox-modal.component';
import { ConfirmationCheckboxModalOptions, ConfirmationCheckboxModalResponse } from './models';

export interface ConfirmationCheckboxModalRef {
  result: ConfirmationCheckboxModalResponse | undefined;
  close: (result: ConfirmationCheckboxModalResponse) => void;
  dismiss: (reason?: ConfirmationCheckboxModalResponse) => void;
}

@Injectable({ providedIn: 'root' })
export class ConfirmationCheckboxModalService {
  constructor(private readonly modalController: FrontendModalService) {}

  confirm(options: ConfirmationCheckboxModalOptions): Observable<ConfirmationCheckboxModalRef> {
    return this.modalController.create<ConfirmationCheckboxModalComponent, ConfirmationCheckboxModalResult>(
      ConfirmationCheckboxModalComponent,
      { options },
      FrontendModalSize.default,
      options.backdropDismiss,
    )
      .pipe(
        take(1),
        map(modalResult => ({
          result: modalResult?.response,
          close: (result): void => modalResult.instance.confirm(),
          dismiss: (reason): void => modalResult.instance.close()
        }))
      );
  }
}
